export default __webpack_public_path__ + "static/media/529.1b577032.jpg";